const ExpertiseReport = () =>
  import(
    /* webpackChunkName: "base-info-courier-expertise" */ '@/pages/base-info/courier/expertise/index.vue'
  )
const CreateCourierExpertise = () =>
  import(
    /* webpackChunkName: "base-info-courier-expertise" */ '@/pages/base-info/courier/expertise/create.vue'
  )
const EditCourierExpertise = () =>
  import(
    /* webpackChunkName: "base-info-courier-expertise" */ '@/pages/base-info/courier/expertise/edit.vue'
  )

export default {
  path: 'expertise',
  meta: {
    label: 'expertise',
    auth: 'expertise'
  },
  component: {
    name: 'Expertise',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoCourierExpertise',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: ExpertiseReport
    },
    {
      name: 'BaseInfoCreateCourierExpertise',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateCourierExpertise
    },
    {
      name: 'BaseInfoEditCourierExpertise',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditCourierExpertise,
      props: true
    }
  ]
}
